"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getSortDirectionAsString = void 0;
var SortDirections = {
  ASCENDING: 1,
  DESCENDING: -1,
  NONE: 0
};

var getSortDirectionAsString = function getSortDirectionAsString(sortDir) {
  if (sortDir === SortDirections.ASCENDING) {
    return 'ascending';
  } else if (sortDir === SortDirections.DESCENDING) {
    return 'descending';
  }

  return 'none';
};

exports.getSortDirectionAsString = getSortDirectionAsString;
var _default = SortDirections;
exports.default = _default;